import React from 'react';

export const MenuSeparator = () => {
  return <div className="bg-gray-light h-px md:mb-1 md:mt-6" />;
};
